var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            [
              _vm.saveSubmitBtnShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProductQuoteSave,
                          expression: "ProductQuoteSave",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateQuotation("save")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.saveSubmitBtnShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProductQuoteSave,
                          expression: "ProductQuoteSave",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateQuotation("submit")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "headDataForm",
              staticClass: "topform",
              attrs: {
                "label-width": "120px",
                model: _vm.headData,
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "handle-input",
                          attrs: { label: "单据编号" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.applyNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "applyNo", $$v)
                              },
                              expression: "headData.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "subject", $$v)
                              },
                              expression: "headData.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "name", $$v)
                              },
                              expression: "headData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: "选择日期",
                              disabled: "",
                            },
                            model: {
                              value: _vm.headData.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "createDate", $$v)
                              },
                              expression: "headData.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "产品报价明细", name: "first" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "flex", justify: "start", align: "middle" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.exportDetail },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.export")))]
                  ),
                  _vm.saveSubmitBtnShow
                    ? _c(
                        "el-upload",
                        {
                          staticClass: "apply-import-button",
                          attrs: {
                            "on-error": _vm.importDetailError,
                            "on-success": _vm.importDetailSuccess,
                            "before-upload": _vm.beforeUpload,
                            "show-file-list": false,
                            action: _vm.importDetailUrl,
                            multiple: false,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "mini", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("common.import")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "ux-grid",
                {
                  ref: "quotationLineTableDataRef",
                  attrs: {
                    data: _vm.quotationLineTableData,
                    "keep-source": "",
                    "max-height": "550",
                    "show-overflow": "tooltip",
                  },
                  on: { "sort-change": _vm.changeSort },
                },
                [
                  _c("ux-table-column", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saveSubmitBtnShow,
                        expression: "saveSubmitBtnShow",
                      },
                    ],
                    attrs: {
                      align: "center",
                      title: "操作",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.onEdit(scope)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "序号",
                      type: "index",
                      width: "60",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "供应商",
                      field: "supplierName",
                      "min-width": "160px",
                      fixed: "",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "8位码",
                      field: "eightBitCode",
                      "min-width": "100",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "8位码名称",
                      field: "eightBitCodeName",
                      "min-width": "160px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "提货点",
                      field: "pickupPoint",
                      "min-width": "120",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "到货仓库",
                      field: "dcName",
                      "min-width": "160px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "温区",
                      field: "temperatureI18n",
                      "min-width": "80px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "有效开始日期",
                      field: "effectiveBeginDate",
                      "min-width": "160",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "非标准线路运费",
                      field: "isSpecialFreight",
                      "min-width": "160px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("setIsSpecialFreight")(
                                    scope.row.isSpecialFreight
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "运输方式",
                      field: "transportaionMethod",
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("ic")(
                                    scope.row.transportaionMethod,
                                    "COMMON",
                                    "TRANSPORTAION_METHOD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "线路结算单位",
                      field: "lineUnit",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("ic")(
                                    scope.row.lineUnit,
                                    "COMMON",
                                    "UNIT"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "线路价格",
                      field: "linePrice",
                      "min-width": "120px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "产品运费（不含税）",
                      field: "productPrice",
                      "min-width": "170px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "现有产品价格",
                      field: "currentProductPrice",
                      "min-width": "140",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "价格变化",
                      field: "changeRate",
                      "min-width": "120px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "LeadTime",
                      field: "leadTime",
                      "min-width": "120px",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "外包装长(cm)",
                      field: "externalPackagingLength",
                      "min-width": "140",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "外包装宽(cm)",
                      field: "externalPackagingWidth",
                      "min-width": "140",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "外包装高(cm)",
                      field: "externalPackagingHeight",
                      "min-width": "140",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "外包装净重(kg)",
                      field: "externalPackagingNetweight",
                      "min-width": "160",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "外包装毛重(kg)",
                      field: "externalPackagingGrossweight",
                      "min-width": "160",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "每Pallet层数",
                      field: "palletLayerNumber",
                      "min-width": "160",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "每层箱数",
                      field: "palletLayerBoxNumber",
                      "min-width": "120",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "托盘上物品长度(cm)",
                      field: "palletItemsLength",
                      "min-width": "180",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "托盘上物品宽度(cm)",
                      field: "palletItemsWidth",
                      "min-width": "180",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "托盘上物品高度(cm)",
                      field: "palletItemsHeight",
                      "min-width": "180",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "备注",
                      field: "remarks",
                      "min-width": "180",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "附件", name: "second" } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showUploadFlag,
                      expression: "showUploadFlag",
                    },
                  ],
                  ref: "upload",
                  staticStyle: { float: "left" },
                  attrs: {
                    action: "upload",
                    "http-request": _vm.uploadConfirm,
                    "show-file-list": false,
                    multiple: "",
                    name: "file",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                      },
                      slot: "trigger",
                    },
                    [_vm._v("选取文件")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.fileList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "documentName",
                      label: _vm.$t("common.file"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadFile(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "userName",
                      label: _vm.$t("common.createBy"),
                      "min-width": "130px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "createDate",
                      label: _vm.$t("common.createDate"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.createDate,
                                    "YYYY-MM-DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.showUploadFlag
                    ? _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "tmDocumentId",
                          "min-width": "130px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.deleteFile(
                                            scope.row.tmDocumentId,
                                            scope.$index,
                                            _vm.fileList
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.del")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4140023628
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _c(
            "el-table",
            {
              ref: "tableDataRef",
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                "max-height": "470",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "supplierName",
                  "min-width": "160px",
                  label: "供应商",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "eightBitCode",
                  width: "140",
                  label: "8位码",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "eightBitCodeName",
                  "min-width": "160px",
                  label: "8位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "pickupPoint",
                  "min-width": "160px",
                  label: "提货点",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "dcName",
                  "min-width": "160px",
                  label: "到货仓库",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "temperatureI18n",
                  "min-width": "80px",
                  label: "温区",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "effectiveBeginDate",
                  "min-width": "200px",
                  label: "有效开始日期",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "picker-options":
                              _vm.headData.applyType == 4
                                ? _vm.pickerOptions
                                : "",
                            "value-format": "yyyy-MM-dd",
                            type: "date",
                            placeholder: _vm.$t("common.selDate"),
                          },
                          model: {
                            value: scope.row.effectiveBeginDate,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "effectiveBeginDate", $$v)
                            },
                            expression: "scope.row.effectiveBeginDate",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "isSpecialFreight",
                  label: "非标准线路运费",
                  "min-width": "160px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("ic-select", {
                          attrs: { options: { Y: "是", N: "否" } },
                          on: {
                            change: function ($event) {
                              return _vm.calcQuotationProductPrice(
                                scope.row,
                                scope.$index,
                                "N"
                              )
                            },
                          },
                          model: {
                            value: scope.row.isSpecialFreight,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isSpecialFreight", $$v)
                            },
                            expression: "scope.row.isSpecialFreight",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "transportaionMethod",
                  label: "运输方式",
                  "min-width": "120px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("ic-select", {
                          attrs: {
                            table: "COMMON",
                            field: "TRANSPORTAION_METHOD",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.calcQuotationProductPrice(
                                scope.row,
                                scope.$index,
                                "N"
                              )
                            },
                          },
                          model: {
                            value: scope.row.transportaionMethod,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "transportaionMethod", $$v)
                            },
                            expression: "scope.row.transportaionMethod",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "lineUnit",
                  label: "线路结算单位",
                  "min-width": "120px",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.isSpecialFreight == "N"
                          ? [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  attrs: { disabled: scope.row.lineDisabled },
                                  on: {
                                    change: function ($event) {
                                      return _vm.calcQuotationProductPrice(
                                        scope.row,
                                        scope.$index,
                                        "N"
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.lineUnit,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "lineUnit", $$v)
                                    },
                                    expression: "scope.row.lineUnit",
                                  },
                                },
                                _vm._l(_vm.unitList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm._f("inputChoiceI18n")(item),
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "linePrice",
                  label: "线路价格",
                  "min-width": "100px",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.isSpecialFreight == "N"
                          ? [
                              _c("el-input", {
                                attrs: { disabled: scope.row.lineDisabled },
                                on: {
                                  blur: function ($event) {
                                    return _vm.calcQuotationProductPrice(
                                      scope.row,
                                      scope.$index,
                                      "Y"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.linePrice,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "linePrice", $$v)
                                  },
                                  expression: "scope.row.linePrice",
                                },
                              }),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "productPrice",
                  label: "产品运费（不含税）",
                  "min-width": "170px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.productPriceDisabledM(scope.row),
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.setPrice(
                                scope.row.productPrice,
                                scope.$index
                              )
                            },
                          },
                          model: {
                            value: scope.row.productPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "productPrice", $$v)
                            },
                            expression: "scope.row.productPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "currentProductPrice",
                  label: "现有产品价格",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "changeRate",
                  label: "价格变化",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "leadTime",
                  label: "LeadTime",
                  width: "160px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          model: {
                            value: scope.row.leadTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "leadTime", $$v)
                            },
                            expression: "scope.row.leadTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "externalPackagingLength",
                  label: "外包装长(cm)",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "externalPackagingWidth",
                  label: "外包装宽(cm)",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "externalPackagingHeight",
                  label: "外包装高(cm)",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "externalPackagingNetweight",
                  label: "外包装净重(kg)",
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "externalPackagingGrossweight",
                  label: "外包装毛重(kg)",
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "palletLayerNumber",
                  label: "每Pallet层数",
                  "min-width": "120px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "palletLayerBoxNumber",
                  label: "每层箱数",
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "palletItemsLength",
                  label: "托盘上物品长度(cm)",
                  "min-width": "170px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "palletItemsWidth",
                  label: "托盘上物品宽度(cm)",
                  "min-width": "170px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "custom",
                  prop: "palletItemsHeight",
                  label: "托盘上物品高度(cm)",
                  "min-width": "170px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "remarks",
                  label: "备注",
                  width: "220px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { disabled: _vm.remarkDisabledM(scope.row) },
                          model: {
                            value: scope.row.remarks,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "remarks", $$v)
                            },
                            expression: "scope.row.remarks",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }